import React, { Fragment, memo, useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { getLiteral } from 'utils/getLiteral';
import DocumentsAddPopOver from './popovers/DocumentsAddPopOver';
import { WidgetHeaderLayout } from 'containers/components/widgets/Layouts';

import './styles.scss';

const propTypes = {
    canCreate: PropTypes.bool,
    tabSelected: PropTypes.number,
    onSelectTab: PropTypes.func,
    dataDocuments: PropTypes.array,
    dataSigned: PropTypes.array,
    folderSelectedArr: PropTypes.array,
    entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    entityType: PropTypes.object,
    fetchData: PropTypes.func,
};

const Header = memo(
    ({
        canCreate,
        folderSelectedArr,
        tabSelected,
        onSelectTab,
        dataDocuments,
        dataSigned,
        entityId,
        entityType,
        fetchData,
    }) => {
        const [openAddPopOver, setOpenAddPopover] = useState(false);
        const [anchorEl, setAnchorEl] = useState(null);

        const onClickAdd = useCallback((event) => {
            event.preventDefault();
            setOpenAddPopover(true);
            setAnchorEl(event.currentTarget);
        }, []);

        const onClickOutsideAdd = useCallback(() => {
            setOpenAddPopover(false);
        }, []);

        const onlyFiles = useMemo(
            () => dataDocuments.filter((current) => current.is_folder === '0'),
            [dataDocuments],
        );

        const tabsConfig = useMemo(() => {
            const totalDocuments = onlyFiles.length;
            const totalSigned = dataSigned.length;
            return [
                {
                    title: getLiteral('title_documents'),
                    count: totalDocuments || '0',
                },
                {
                    title: getLiteral('label_documents_signed'),
                    count: totalSigned || '0',
                },
            ];
        }, [dataSigned, onlyFiles]);

        const folderSelected = useMemo(
            () => folderSelectedArr[folderSelectedArr.length - 1],
            [folderSelectedArr],
        );

        const showAdd = useMemo(() => canCreate && tabSelected !== 1, [canCreate, tabSelected]);

        return (
            <Fragment>
                <WidgetHeaderLayout
                    content={tabsConfig}
                    onClickAdd={showAdd ? onClickAdd : undefined}
                    tabControlled={tabSelected}
                    onSelectTab={onSelectTab}
                />
                <DocumentsAddPopOver
                    open={openAddPopOver}
                    anchorEl={anchorEl}
                    onRequestClose={onClickOutsideAdd}
                    entityId={entityId}
                    entityType={entityType}
                    fetchData={fetchData}
                    folderSelected={folderSelected}
                />
            </Fragment>
        );
    },
);

Header.propTypes = propTypes;

export default Header;
